import * as yup from 'yup';

const schema = yup.object().shape({
  nome: yup.string().required('Nome do Perfil é um campo obrigatório.'),
});

export default schema;
